import { coordsLabel } from "@/data/beaches";
import { useLang } from "@/lib/i18n";

const headCls = "text-[9.5px] tracking-[0.14em] uppercase font-black text-[#9CA3AF] py-3 pr-5 text-left whitespace-nowrap";

/** Overview table — every beach at a glance. Scrolls sideways on small screens. */
export default function BeachCompareTable({ beaches = [] }) {
  const { t } = useLang();

  return (
    <div className="mt-5 bg-white border border-[#E5E7EB] rounded-[16px] overflow-x-auto no-scrollbar">
      <table className="w-full min-w-[720px] border-collapse">
        <thead>
          <tr className="border-b border-[#F3F4F6]">
            <th className={headCls}>{t("beach.col.beach")}</th>
            <th className={headCls}>{t("beach.col.area")}</th>
            <th className={headCls}>{t("beach.col.coords")}</th>
            <th className={headCls}>{t("beach.col.bestFor")}</th>
            <th className={`${headCls} pr-5`}>{t("beach.col.water")}</th>
          </tr>
        </thead>
        <tbody>
          {beaches.map((beach) => (
            <tr key={beach.slug} className="border-b border-[#F3F4F6] last:border-b-0">
              <td className="py-3.5 pr-5 text-[13px] font-extrabold text-[#111827] whitespace-nowrap">
                {beach.name}
              </td>
              <td className="py-3.5 pr-5 text-[13px] text-[#4B5563] whitespace-nowrap">{beach.area}</td>
              <td className="py-3.5 pr-5 text-[12.5px] font-bold text-[#6B7280] whitespace-nowrap">
                {coordsLabel(beach)}
              </td>
              <td className="py-3.5 pr-5 text-[13px] text-[#4B5563] whitespace-nowrap">{beach.bestFor}</td>
              <td className="py-3.5 pr-5 text-[13px] text-[#4B5563] whitespace-nowrap">{beach.water}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}